export default __webpack_public_path__ + "static/media/eliminar.16df07be.svg";